<script setup>
import { Textarea } from "@codinglabsau/ui";
import useNodeProps from "@/Composables/useNodeProps"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"
import { nextTick, onMounted, ref } from "vue"
import { CodeBracketIcon } from "@heroicons/vue/24/solid"
import EditableNodeWrapper from "../../Components/EditableNodeWrapper.vue";
import { NodeViewWrapper, nodeViewProps } from "@tiptap/vue-3"

const props = defineProps({
  ...nodeViewProps,
})

let { html } = useNodeProps(props)

let showCode = ref(false)

onMounted(() => {
  if (html.value === '') {
    nextTick(() => showCode.value = true)
  }
})
</script>

<template>
  <node-view-wrapper>
    <EditableNodeWrapper v-bind="props">
      <template #tools>
        <ToolbarButton :icon="CodeBracketIcon" label="Toggle Code" v-model="showCode" toggle />
      </template>
      <template #content>
        <div v-show="showCode" class="text-center space-y-1 not-prose">
          <Textarea
            v-model="html"
            class="w-full h-64"
            placeholder="Paste HTML code here"
          />
        </div>
        <div v-show="!showCode" class="not-prose">
          <div v-if="html" v-html="html"></div>
          <div v-else class="p-6 text-center text-sm text-gray-400">No HTML provided</div>
        </div>
      </template>
    </EditableNodeWrapper>
  </node-view-wrapper>
</template>
